import { Card, Col, Row, Modal } from "antd";
import React, { useState } from "react";
import Dhol1 from "../../src/assetes/Dhol/dhol1.jpeg";
import Dhol2 from "../../src/assetes/Dhol/dhol2.jpeg";
import Dhol3 from "../../src/assetes/Dhol/dhol3.jpeg";
import Dhol4 from "../../src/assetes/Dhol/dhol4.jpeg";
import Dhol5 from "../../src/assetes/Dhol/dhol5.jpeg";
import Dhol6 from "../../src/assetes/Dhol/dhol6.jpeg";
import Dhol7 from "../../src/assetes/Dhol/dhol7.jpeg";
import Dhol8 from "../../src/assetes/Dhol/dhol8.jpeg";
import Dhol9 from "../../src/assetes/Dhol/dhol9.jpeg";
import Dhol10 from "../../src/assetes/Dhol/dhol10.jpeg";
import Dhol11 from "../../src/assetes/Dhol/dhol11.jpeg";
import Dhol12 from "../../src/assetes/Dhol/dhol12.jpeg";

import Sagar from "../../src/assetes/shiv/sagar.jpeg";
import Hanuman from "../../src/assetes/shiv/hanuman.jpeg";
import Narendra from "../../src/assetes/shiv/narendra.jpeg";
import Nishant from "../../src/assetes/shiv/nishant.jpeg";
import Pratik from "../../src/assetes/shiv/pratik.jpeg";
import Vikarnt from "../../src/assetes/shiv/vikrant.jpeg";

import Anup from "../../src/assetes/shiv/anup.jpeg";
import Saurabh from "../../src/assetes/shiv/saurabh.jpeg";
import Sameer from "../../src/assetes/shiv/sameer.jpeg";
import Aniket from "../../src/assetes/shiv/aniket.jpeg";

import Trek1 from "../../src/assetes/trek/trek1.jpeg";
import Trek2 from "../../src/assetes/trek/trek2.jpeg";
import Trek3 from "../../src/assetes/trek/trek3.jpeg";
import Trek4 from "../../src/assetes/trek/trek4.jpeg";
import Trek5 from "../../src/assetes/trek/trek5.jpeg";
import Trek6 from "../../src/assetes/trek/trek6.jpeg";
import Trek7 from "../../src/assetes/trek/trek7.jpeg";
import Trek8 from "../../src/assetes/trek/trek8.jpeg";
import Trek9 from "../../src/assetes/trek/trek9.jpeg";
import Trek10 from "../../src/assetes/trek/trek10.jpeg";
import Trek11 from "../../src/assetes/trek/trek11.jpeg";
import Trek12 from "../../src/assetes/trek/trek12.jpeg";
import Trek13 from "../../src/assetes/trek/trek13.jpeg";
import Trek14 from "../../src/assetes/trek/trek14.jpeg";
import Trek15 from "../../src/assetes/trek/trek15.jpeg";
import Trek16 from "../../src/assetes/trek/trek16.jpeg";
import Trek17 from "../../src/assetes/trek/trek17.jpeg";
import Trek18 from "../../src/assetes/trek/trek18.jpeg";
import Trek19 from "../../src/assetes/trek/trek19.jpeg";
import Trek20 from "../../src/assetes/trek/trek20.jpeg";

import Samiti1 from "../../src/assetes/samiti/samiti1.jpeg";
import Samiti2 from "../../src/assetes/samiti/samiti2.jpeg";
import Samiti3 from "../../src/assetes/samiti/samiti3.jpeg";
import Samiti4 from "../../src/assetes/samiti/samiti4.jpeg";
import Samiti5 from "../../src/assetes/samiti/samiti5.jpeg";
import Samiti6 from "../../src/assetes/samiti/samiti6.jpeg";
import Samiti7 from "../../src/assetes/samiti/samiti7.jpeg";

import { Tabs } from "antd";
import { v4 as uuidv4 } from "uuid";

const Event = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isModalOpenTrek, setIsModalOpenTrek] = useState(false);

  const [isModalOpenSamiti, setIsModalOpenSamiti] = useState(false);

  const DholComponent = () => {
    return (
      <div className="flex justify-center">
        <div
          className="flex flex-col sm:w-3/6 px-16 sm:px-0 py-10 rounded-md shadow-md"
          onClick={() => setIsModalOpen(!isModalOpen)}
        >
          <div className="w-full h-60 cursor-pointer">
            <img src={Dhol1} className="w-full h-full object-cover rounded-t" />
          </div>
          <div className="flex flex-row justify-between cursor-pointer">
            <img src={Dhol2} className="sm:w-40 w-20" />
            <img src={Dhol3} className="sm:w-40 w-20" />
            <img src={Dhol4} className="sm:w-40 w-20" />
            <img src={Dhol5} className="sm:w-40 w-20 sm:block hidden" />
          </div>

          <div>
            <div className="flex flex-wrap justify-center gap-20 mt-5">
              <div className="w-56 shadow-md p-3 rounded-md border border-1">
                <img src={Anup} className="w-full h-60 rounded-md" />
                <p className="text-center text-sm mt-3">
                  अनुप म्हात्रे (अध्यक्ष)
                </p>
              </div>

              <div className="w-56 shadow-md p-3 rounded-md border border-1">
                <img src={Saurabh} className="w-full h-60 rounded-md" />
                <p className="text-center text-sm mt-3">
                  सौरभ बाळासाहेब भलेगरे (उपाध्यक्ष)
                </p>
              </div>

              <div className="w-56 shadow-md p-3 rounded-md border border-1">
                <img src={Sameer} className="w-full h-60 rounded-md" />
                <p className="text-center text-sm mt-3">
                  समीर राजेंद्र जाधव (पथक प्रमुख)
                </p>
              </div>

              <div className="w-56 shadow-md p-3 rounded-md border border-1">
                <img src={Aniket} className="w-full h-60 rounded-md" />
                <p className="text-center text-sm mt-3">
                  अनिकेत पांडुरंग म्हात्रे (उपपथक प्रमुख)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const TrekComponent = () => {
    return (
      <div className="flex justify-center">
        <div
          className="flex flex-col sm:w-3/6 py-10 rounded-md shadow-md"
          onClick={() => setIsModalOpenTrek(!isModalOpenTrek)}
        >
          <div className="w-full h-60 cursor-pointer">
            <img src={Trek1} className="w-full h-full object-cover rounded-t" />
          </div>
          <div className="flex flex-row justify-between cursor-pointer">
            <img src={Trek2} className="sm:w-40 w-20" />
            <img src={Trek3} className="sm:w-40 w-20" />
            <img src={Trek4} className="sm:w-40 w-20" />
            <img src={Trek5} className="sm:w-40 w-20 sm:block hidden" />
          </div>

          <div>
            <div className="flex flex-wrap justify-center gap-20 mt-5">
              <div className="w-56 shadow-md p-3 rounded-md border border-1">
                <img src={Narendra} className="w-full h-60 rounded-md" />
                <p className="text-center text-sm mt-3">
                  नरेंद्र विजय चाचड (अध्यक्ष)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const SamitiComponent = () => {
    return (
      <div className="flex justify-center">
        <div
          className="flex flex-col sm:w-3/6 py-10 rounded-md shadow-md"
          onClick={() => setIsModalOpenSamiti(!isModalOpenSamiti)}
        >
          <div className="w-full h-60 cursor-pointer">
            <img
              src={Samiti1}
              className="w-full h-full object-cover rounded-t"
            />
          </div>
          <div className="flex flex-row justify-between cursor-pointer">
            <img src={Samiti2} className="sm:w-40 w-20" />
            <img src={Samiti3} className="sm:w-40 w-20" />
            <img src={Samiti4} className="sm:w-40 w-20" />
            <img src={Samiti5} className="sm:w-40 w-20 sm:block hidden" />
          </div>

          <div>
            <div className="flex flex-wrap justify-center gap-20 mt-5">
              <div className="w-56 shadow-md p-3 rounded-md border border-1">
                <img src={Pratik} className="w-full h-60 rounded-md" />
                <p className="text-center text-sm mt-3">
                  प्रतिक प्रकाश चाचड (अध्यक्ष)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCancelTrek = () => {
    setIsModalOpenTrek(false);
  };

  const handleCancelSamiti = () => {
    setIsModalOpenSamiti(false);
  };

  const tabItems = [
    {
      label: <h1>श्री शिव सह्याद्री ढोल ताशे ध्वज पथक </h1>,
      key: uuidv4(),
      children: <DholComponent />,
    },
    {
      label: "श्री शिव राज्याभिषेक समिती ",
      key: uuidv4(),
      children: <SamitiComponent />,
    },
    {
      label: " लक्ष्य ट्रेकर्स ",
      key: uuidv4(),
      children: <TrekComponent />,
    },
  ];

  return (
    <div className="w-full">
      <div className="mt-10">
        <p className="text-center">
          श्री शिव सह्याद्री संस्था, महाराष्ट्र राज्य
        </p>
        <p className="text-center mt-5">मुख्य कार्यकारी अधिकारी</p>

        <div className="flex flex-wrap justify-center gap-20 mt-5">
          <div className="w-56 shadow-md p-3 rounded-md border border-1">
            <img src={Sagar} className="w-full h-60 rounded-md" />
            <p className="text-center text-sm mt-3">
              सागर कृष्णा मुंढे (अध्यक्ष)
            </p>
          </div>
          <div className="w-56 shadow-md p-3 rounded-md border border-1">
            <img src={Hanuman} className="w-full h-60 rounded-md" />
            <p className="text-center text-sm mt-3">
              हनुमान वायभासे (उपाध्यक्ष)
            </p>
          </div>
          <div className="w-56 shadow-md p-3 rounded-md border border-1">
            <img src={Narendra} className="w-full h-60 rounded-md" />
            <p className="text-center text-sm mt-3">
              नरेंद्र विजय चाचड (चिटणीस )
            </p>
          </div>
          <div className="w-56 shadow-md p-3 rounded-md border border-1">
            <img src={Nishant} className="w-full h-60 rounded-md" />
            <p className="text-center text-sm mt-3">
              निशांत राजेंद्र म्हात्रे (खजिनदार )
            </p>
          </div>
          <div className="w-56 shadow-md p-3 rounded-md border border-1">
            <img src={Pratik} className="w-full h-60 rounded-md" />
            <p className="text-center text-sm mt-3">
              प्रतिक प्रकाश चाचड <br />
              (विशेष कार्यकारी अधिकारी )
            </p>
          </div>
          <div className="w-56 shadow-md p-3 rounded-md border border-1">
            <img src={Vikarnt} className="w-full h-60 rounded-md" />
            <p className="text-center text-sm mt-3">
              विक्रांत बाळासाहेब पाटील <br /> (प्रमुख सल्लागार)
            </p>
          </div>
        </div>
      </div>

      <div className="mt-5 w-full">
        <p className="mt-10 text-center">
          संस्थे अंतर्गत इतर कार्यकारी अधिकारी
        </p>
        <Tabs defaultActiveKey="1" centered items={tabItems} />
      </div>

      <Modal
        title="श्री शिव सह्याद्री ढोल ताशे ध्वज पथक"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        width="70%"
      >
        <div>
          <div>
            <img src={Dhol1} />
          </div>
          <div>
            <img src={Dhol2} />
          </div>
          <div>
            <img src={Dhol3} />
          </div>
          <div>
            <img src={Dhol4} />
          </div>
          <div>
            <img src={Dhol5} />
          </div>
          <div>
            <img src={Dhol6} />
          </div>
          <div>
            <img src={Dhol7} />
          </div>
          <div>
            <img src={Dhol8} />
          </div>
          <div>
            <img src={Dhol9} />
          </div>
          <div>
            <img src={Dhol10} />
          </div>
          <div>
            <img src={Dhol11} />
          </div>
          <div>
            <img src={Dhol12} />
          </div>
        </div>
      </Modal>

      <Modal
        title="लक्ष्य ट्रेकर्स"
        open={isModalOpenTrek}
        onCancel={handleCancelTrek}
        footer={null}
        width="70%"
      >
        <div>
          <img src={Trek1} />
        </div>
        <div>
          <img src={Trek2} />
        </div>
        <div>
          <img src={Trek3} />
        </div>
        <div>
          <img src={Trek4} />
        </div>
        <div>
          <img src={Trek5} />
        </div>
        <div>
          <img src={Trek6} />
        </div>
        <div>
          <img src={Trek7} />
        </div>
        <div>
          <img src={Trek8} />
        </div>
        <div>
          <img src={Trek9} />
        </div>
        <div>
          <img src={Trek10} />
        </div>
        <div>
          <img src={Trek11} />
        </div>
        <div>
          <img src={Trek12} />
        </div>
        <div>
          <img src={Trek13} />
        </div>
        <div>
          <img src={Trek14} />
        </div>
        <div>
          <img src={Trek15} />
        </div>
        <div>
          <img src={Trek16} />
        </div>
        <div>
          <img src={Trek17} />
        </div>
        <div>
          <img src={Trek18} />
        </div>
        <div>
          <img src={Trek19} />
        </div>
        <div>
          <img src={Trek20} />
        </div>
      </Modal>

      <Modal
        title="श्री शिव राज्याभिषेक समिती "
        open={isModalOpenSamiti}
        onCancel={handleCancelSamiti}
        footer={null}
        width="70%"
      >
        <div>
          <img src={Samiti1} />
        </div>
        <div>
          <img src={Samiti2} />
        </div>
        <div>
          <img src={Samiti3} />
        </div>
        <div>
          <img src={Samiti4} />
        </div>
        <div>
          <img src={Samiti5} />
        </div>
        <div>
          <img src={Samiti6} />
        </div>
        <div>
          <img src={Samiti7} />
        </div>
      </Modal>
    </div>
  );
};

export default Event;
